export default __webpack_public_path__ + "static/media/app2-23.9466fcdf.jpg";